import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const mapyMapmenuTitleCss = ":host{display:flex;padding:8px 16px;align-items:center;gap:8px;color:#000000;font-family:Arial, Helvetica, sans-serif;font-size:14px;font-style:normal;font-weight:400;line-height:20px;user-select:none}";

const MapyMapmenuTitle$1 = /*@__PURE__*/ proxyCustomElement(class MapyMapmenuTitle extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
  }
  render() {
    return h(Host, null, h("slot", null));
  }
  static get style() { return mapyMapmenuTitleCss; }
}, [1, "mapy-mapmenu-title"]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["mapy-mapmenu-title"];
  components.forEach(tagName => { switch (tagName) {
    case "mapy-mapmenu-title":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, MapyMapmenuTitle$1);
      }
      break;
  } });
}
defineCustomElement$1();

const MapyMapmenuTitle = MapyMapmenuTitle$1;
const defineCustomElement = defineCustomElement$1;

export { MapyMapmenuTitle, defineCustomElement };

//# sourceMappingURL=mapy-mapmenu-title.js.map